/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getActorMetadata.defs.js'
export * as $defs from './getActorMetadata.defs.js'
